import React from 'react'
import Logo from '../../assets/Images/logo.png'
import { Link } from 'react-router-dom'
import '../header/Header.css'
import HeaderNotification from '../notification/HeaderNotification'
import ThemeToggle from '../../ThemeToggle'


const Header = () => {
  return (
      <header>
        <div className='header-details d-flex flex-wrap justify-content-between'>
            <div className='logo-box'>
                <Link rel="stylesheet" to="/home">
                    <img src={Logo} alt="" />
                </Link>
            </div>
            <div className='right-box d-flex flex-wrap align-items-center'>
                <ThemeToggle />
                <div className='btn-box-right d-flex flex-wrap align-items-center'>
                    <div className='notification-box'>
                        <button className='notification-item dropdown-toggle' data-bs-toggle="dropdown" aria-expanded="false"> <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0201 2.91C8.71009 2.91 6.02009 5.6 6.02009 8.91V11.8C6.02009 12.41 5.76009 13.34 5.45009 13.86L4.30009 15.77C3.59009 16.95 4.08009 18.26 5.38009 18.7C9.69009 20.14 14.3401 20.14 18.6501 18.7C19.8601 18.3 20.3901 16.87 19.7301 15.77L18.5801 13.86C18.2801 13.34 18.0201 12.41 18.0201 11.8V8.91C18.0201 5.61 15.3201 2.91 12.0201 2.91Z" stroke="#787486" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/><path d="M13.8699 3.2C13.5599 3.11 13.2399 3.04 12.9099 3C11.9499 2.88 11.0299 2.95 10.1699 3.2C10.4599 2.46 11.1799 1.94 12.0199 1.94C12.8599 1.94 13.5799 2.46 13.8699 3.2Z" stroke="#787486" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.02 19.06C15.02 20.71 13.67 22.06 12.02 22.06C11.2 22.06 10.44 21.72 9.90002 21.18C9.36002 20.64 9.02002 19.88 9.02002 19.06" stroke="#787486" stroke-width="1.5" stroke-miterlimit="10"/><circle cx="18" cy="4" r="3" fill="#D8727D"/></svg><span className='active-dot'></span></button>
                        <div className='dropdown-menu dropdown-menu-end'>
                            <HeaderNotification />
                        </div>
                    </div>
                </div>

                <div className='myAccWrapper'>
                    <button className='myAcc d-flex align-items-center dropdown-toggle' data-bs-toggle="dropdown" aria-expanded="false">
                        <div className='UserInfo'>
                            Welcome back, Tom
                        </div>
                        <span className='dropdown-icons'>
                            <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.99989 6.60001C6.47489 6.60001 5.94989 6.39751 5.55239 6.00001L0.662393 1.11001C0.444893 0.892511 0.444893 0.532511 0.662393 0.315011C0.879893 0.097511 1.23989 0.097511 1.45739 0.315011L6.34739 5.20501C6.70739 5.56501 7.29239 5.56501 7.65239 5.20501L12.5424 0.315011C12.7599 0.097511 13.1199 0.097511 13.3374 0.315011C13.5549 0.532511 13.5549 0.892511 13.3374 1.11001L8.44739 6.00001C8.04989 6.39751 7.52489 6.60001 6.99989 6.60001Z" fill="#292D32"/></svg>
                        </span>
                    </button>
                    <div className='dropdown-menu'>
                        <ul className="admin-details-menu">
                            <li><Link  rel="stylesheet" className="btn btn-blue dropdown-item" to="/signup">Sign up</Link></li>
                            <li><Link  rel="stylesheet" className="btn btn-blue dropdown-item" to="/home">Go to Home</Link></li>
                            <li><Link rel="stylesheet" className="btn btn-blue dropdown-item" to=""><span className="icons"></span> Logout</Link></li>
                            <li><Link rel="stylesheet" className="btn btn-blue dropdown-item " to="/client-profile"> Profile Client</Link></li>
                            <li><Link rel="stylesheet" className="btn btn-blue dropdown-item " to="/sugar-daddy"> Sugar Daddy</Link></li>
                        </ul>
                    </div>
                </div>
                
                <button className="btn btn-mobile-hemburger d-block d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#menucanvas" aria-controls="menucanvas">
                    <span className="f-btn" />
                    <span className="s-btn" />
                    <span className="t-btn" />
                </button>
            </div>
        </div>
      </header>
  )
}

export default Header
